<template lang="html">
  <div class="vx-row">
    <div class="vx-col md:w-1/3 w-full mt-5">
      <div class="vx-row">
        <div class="vx-col w-full mt-5">
          <vs-input :label="$t('name') | capitalize" v-model="recipient.name" v-validate="'required'"class="w-full" name="recipientName"/>
          <span class="text-danger text-sm" v-show="errors.has('recipientName')">{{ errors.first('recipientName') }}</span>
        </div>

        <div class="vx-col w-full mt-5">
          <vs-input type="email" :label="$t('email') | capitalize" v-model="recipient.email" class="w-full" v-validate="'required|email'" name="recipientEmail"/>
          <span class="text-danger text-sm" v-show="errors.has('recipientEmail')">{{ errors.first('recipientEmail') }}</span>
        </div>

        <div class="vx-col w-full mt-5">
          <vs-button color="primary" type="filled" class="w-full" icon-pack="feather" icon="icon-plus" @click="addItem">
            {{ $t('add') | capitalize }}
          </vs-button>
        </div>
      </div>
    </div>
    <div class="vx-col md:w-2/3 w-full mt-5">
      <vs-list>
        <vs-list-header :title="$t('recipients')" color="danger"></vs-list-header>

        <vs-list-item :title="item.name" :subtitle="item.email" v-for="(item,index) in value" :key="index">
          <template slot="avatar">
            <vs-avatar />
          </template>
          <vs-button
            color="danger"
            type="flat"
            icon-pack="feather"
            icon="icon-x"
            @click="removeItem(index)"
          ></vs-button>
        </vs-list-item>
      </vs-list>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    default:{
      name: '',
      email: ''
    },
    recipient: {
      name: '',
      email: ''
    },
    list:[]
  }),
  methods: {
    addItem() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.value.unshift({...this.recipient});
          //this.$emit('input',[...this.list]);
          this.recipient = Object.assign({},this.default);
          this.$validator.reset()
        } else {
          // form have errors
        }
      })
    },
    removeItem(index){
        this.value.splice(index, 1)
    }
  },
  props:{
    value:{
      required:true
    }
  }
}
</script>

<style lang="css" scoped>
</style>
